import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { notification } from 'antd'
import { isNil } from 'lodash'

import { apolloService } from '../../common/services'

import { UPDATE_DISHES_STATUS_FLAGS_MUTATION } from '../graphql/mutations'
import { DISHES_PROGRESS_COUNTS_QUERY } from '../graphql/queries'
import {
  FETCH_DISHES_PROGRESS_COUNTS,
  UPDATE_DISH_STATUS_FLAG,
} from '../redux/action-types'

const useUpdateDishesStatusFlagsMutation = fieldName => {
  const dispatch = useDispatch()

  const { data: menuCurationTask } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const onSuccess = useCallback(async () => {
    const result = await apolloService.query({
      query: DISHES_PROGRESS_COUNTS_QUERY,
      variables: { menuId: menuCurationTask?.menu?.id },
      dispatch,
      action: FETCH_DISHES_PROGRESS_COUNTS,
    })

    if (!isNil(result?.data?.dishesProgressCounts)) {
      const { availableForWorkCount, doneCount } =
        result?.data?.dishesProgressCounts || {}

      if (availableForWorkCount && availableForWorkCount === doneCount) {
        notification.success({
          message: 'Success!',
          description: `Dishes are all done! Don't forget to mark the menu as complete.`,
          placement: 'topLeft',
          duration: 10,
        })
      }
    }
  }, [dispatch, menuCurationTask?.menu?.id])

  const mutate = useCallback(
    async (ids, value, shouldOverrideTierOneCheck) =>
      apolloService.mutate({
        mutation: UPDATE_DISHES_STATUS_FLAGS_MUTATION,
        variables: {
          ids,
          data: { [fieldName]: value },
          shouldOverrideTierOneCheck,
        },
        dispatch,
        action: UPDATE_DISH_STATUS_FLAG,
        onSuccess,
      }),
    [dispatch, fieldName, onSuccess],
  )

  return [mutate]
}

export default useUpdateDishesStatusFlagsMutation
